"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TEAM_NAME = exports.PACKAGE_NAME = exports.LIBRARY_NAME = exports.EMOTION_CACHE_KEY = void 0;
/* istanbul ignore file @preserve */
//
// DO NOT EDIT!
// This file was autogenerated by Eddie.
// Changes may cause incorrect behavior and will be lost when the file is regenerated.
//
// Run `npx eddie update workspace` to regenerate.
//

const LIBRARY_NAME = exports.LIBRARY_NAME = 'image-sizes-helper';
const PACKAGE_NAME = exports.PACKAGE_NAME = '@ori/image-sizes-helper';
const TEAM_NAME = exports.TEAM_NAME = 'Frontend Platform';
const EMOTION_CACHE_KEY = exports.EMOTION_CACHE_KEY = `${LIBRARY_NAME}-emotion-cache-key`;
//# sourceMappingURL=constants-generated.js.map